import { hide } from 'redux-modal'
import { refresh } from 'actions/router'
import { PERSONALIZE_VEHICLE_MODAL } from 'constant'

export const closeModal = () => dispatch => {
  dispatch(hide(PERSONALIZE_VEHICLE_MODAL))
  dispatch(refresh())
}
